export const BASE_URL = process.env.REACT_APP_BASE_URL || "https://api.telegaruda.com/v1";
export const API_KEY = process.env.REACT_APP_API_KEY || "56afdabec722ed15af82e69dcec9002a";
export const TELECONSULT_URL = process.env.REACT_APP_TELECONSULT_URL || "https://teleconsult.a2zhealth.com";

export const getAxiosConfig = (token = '') => {
  const authToken = token ? token : sessionStorage.getItem('authToken');
  const headers: Record<string, string> = {
    "Content-Type": "application/json",
    "Accept": "application/json",
  };

  if (authToken) {
    headers["Authorization"] = `Bearer ${authToken}`;
  }

  if (API_KEY) {
    headers["X-API-Key"] = API_KEY;
  }

  return { headers };
};
